import React from 'react'
import { Icon, FieldText } from '@pmi/pmi-iqos-ds-react'
import { constants } from '@pmi/pmi-iqos-shared-react'

const delimiter = constants.EXPIRY_DATE_DELIMITER
const maxLength = delimiter.length + 4
const monthMin = '01'
const monthMax = '12'

const CreditCardExpiryDate = ({
  expiryDate,
  fieldName,
  onExpiryDateChange,
  errors
}) => {
  const handleKeyDown = e => {
    const target = e.target
    const value = target.value
    const key = e.key

    if (/(\d|ArrowLeft|ArrowRight|Backspace|Delete|Tab)/.test(key)) {
      if (/(\d)/.test(key)) {
        if (value.length === maxLength) {
          e.preventDefault()
          handleOnChange(null, target.value)
          return
        }
        // 2 -> 02/
        if (value.length === 0 && key > 1) {
          target.value = '0' + key + delimiter
          e.preventDefault()
        }
        // 16 -> 12/
        if (value.length === 1 && value[0] !== '0' && key > 2) {
          target.value = monthMax + delimiter
          e.preventDefault()
          handleOnChange(null, target.value)
          return
        }
        // 12 -> 12/
        if (value.length === 1) {
          target.value = target.value + key + delimiter
          e.preventDefault()
        }
        // 12+2 -> 12/2
        if (value.length === 2) {
          target.value = target.value + delimiter + key
          e.preventDefault()
          handleOnChange(null, target.value)
          return
        }
        // 00 -> 01/
        if (value === '0' && key === '0') {
          target.value = monthMin + delimiter
          e.preventDefault()
        }

        if (target.value !== value) {
          handleOnChange(null, target.value)
        }
      }
    } else {
      e.preventDefault()
    }
  }

  const compareExpiryDates = (newDate, oldDate) => {
    let newExpiryDate = ''
    for (let i = 0; i < newDate.length; i++) {
      if (newDate[i] === oldDate[i]) {
        newExpiryDate += newDate[i]
      } else {
        return newExpiryDate
      }
    }
    return newExpiryDate
  }

  const handleOnChange = (e, value) => {
    let newValue
    if (e && e.target) {
      newValue = e.target.value
    } else {
      newValue = value
    }
    if (newValue === expiryDate) return

    let newExpiryDate = ''
    if (newValue.length < expiryDate.length) {
      newExpiryDate = compareExpiryDates(newValue, expiryDate)
    } else if (newValue.includes(delimiter) || newValue.length > 2) {
      const arr = newValue.split(delimiter)
      if (arr[0].length > 2) {
        newExpiryDate = compareExpiryDates(newValue, expiryDate)
      } else {
        newExpiryDate = newValue
      }
    } else {
      newExpiryDate = newValue
    }
    onExpiryDateChange(newExpiryDate)
  }

  return (
    <FieldText
      value={expiryDate}
      name={fieldName}
      label={'MM/YY'}
      onKeyDownHandler={handleKeyDown}
      onChangeHandler={handleOnChange}
      icon={Icon.images.bookings}
      errors={errors}
      data-testing="Checkout_FieldText_ExpiryDate"
    />
  )
}

export default CreditCardExpiryDate
